import { useEffect, useState } from "react";
import { getProfile } from "../../services/profileService";

import ProfileHeader from "./ProfileHeader";
import ProfileTabs from "./ProfileTabs";
import ProfileInfo from "./ProfileInfo";
import EditProfile from "./EditProfile";
import WalletHistory from "./WalletHistory";
import ReferralHistory from "./ReferralHistory";
import ChangePassword from "./ChangePassword";
import ReferralSummary from "./ReferralSummary";


import "./profile.css";

export default function ProfileLayout() {
  const [activeTab, setActiveTab] = useState("info");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadProfile = async () => {
      try {
        const data = await getProfile();

        if (data?.status && isMounted) {
          setUser(data.user);
        }
      } catch (err) {
        console.error("Profile load error:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadProfile();

    return () => {
      isMounted = false;
    };
  }, []);

  const renderContent = () => {
    if (!user) return null;

    switch (activeTab) {
      case "edit":
        return (
          <EditProfile
            user={user}
            refreshUser={setUser}
          />
        );

      case "wallet":
        return <WalletHistory />;

      case "referral":
           return (
           <>
          <ReferralSummary user={user} />
           <ReferralHistory />
          </>
        );

      case "password":
        return <ChangePassword />;

      default:
        return <ProfileInfo user={user} />;
    }
  };

  if (loading) {
    return (
      <div className="profile-page">
        <div className="profile-card">Loading profile...</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="profile-page">
        <div className="profile-card">
          Failed to load profile.
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <ProfileHeader user={user} />

      <ProfileTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className="profile-content">
        {renderContent()}
      </div>
    </div>
  );
}
